import { Sentry, integrations as sentryIntegrations } from '@/shared/sentry';

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_CONCIERGE_DSN,
  integrations: sentryIntegrations,
  release: 'polaris@' + process.env.VUE_APP_RELEASE,
  environment: process.env.VUE_APP_POLARIS_SERVER || 'local',
  tracesSampleRate: process.env.VUE_APP_SENTRY_CONCIERGE_TRACES_SAMPLE_RATE || 0.05,
});

import Vue from 'vue';

import router from '@/router';
import App from '@/app.component.vue';

import SuiVue from 'semantic-ui-vue';
import '../semantic/dist/semantic.min.css';
import '@/assets/styles/master.styl';

import * as LogRocket from 'logrocket';
import Analytics from 'analytics-node';

// Variables based on environment
export const DEBUG: boolean = process.env.NODE_ENV === 'development' ? true : false;
export const APIBASEURL: string =
  process.env.NODE_ENV === 'development' ? 'http://0.0.0.0:3031' : process.env.VUE_APP_API_URL || 'http://0.0.0.0:3031';

const hostname = window.location.hostname;
if (process.env.VUE_APP_CONCIERGE_HOSTNAME && !hostname.includes(process.env.VUE_APP_CONCIERGE_HOSTNAME)) {
  const href = window.location.href.replace('/concierge', '');
  window.location.replace(href.replace(hostname, process.env.VUE_APP_CONCIERGE_HOSTNAME));
}

if (process.env.VUE_APP_POLARIS_HOSTNAME && hostname.includes('/portal')) {
  const href = window.location.href.replace('/portal', '');
  window.location.replace(href.replace(hostname, process.env.VUE_APP_POLARIS_HOSTNAME));
}

// Concierge
export const conciergeBASEURL: string =
  process.env.NODE_ENV === 'development'
    ? `http://${window.location.hostname}:9999`
    : `https://${process.env.VUE_APP_CONCIERGE_HOSTNAME}`;

// Polaris
export const polarisBASEURL: string =
  process.env.NODE_ENV === 'development'
    ? `http://${window.location.hostname}:4041`
    : `https://${process.env.VUE_APP_POLARIS_HOSTNAME}`;

// Auth0
export const auth0ConciergeClientID: string = process.env.VUE_APP_AUTH0_M2M_CLIENT_ID || '';
export const auth0DOMAIN: string = process.env.VUE_APP_AUTH0_DOMAIN || '';
if (!auth0DOMAIN && !auth0ConciergeClientID) {
  throw new Error('Auth0 failed to load.');
}

// LogRocket
export const logrocketToken = process.env.VUE_APP_CONCIERGE_LOGROCKET;

// SegmentIO
const segmentIOKEY = process.env.VUE_APP_SEGMENTIO_KEY;
export const analytics = segmentIOKEY ? new Analytics(segmentIOKEY) : null;

export const supportEmail: string = 'onboarding@corvum.io';

export let ipv4 = '';
export let ipv6 = '';

// get IP then =>
let userId = 'Anonymous User';
let logrocketEnabled = true;
fetch('https://api.ipify.org/?format=json').then((response) => {
  response.json().then((data) => {
    ipv4 = data.ip;
    fetch('https://api6.ipify.org?format=json').then((response) => {
      response.json().then((data) => {
        ipv6 = data.ip;
        if (process.env.VUE_APP_USE_LOGROCKET === 'true') {
          logrocketEnabled = true;
        }
        fetch('https://api.corvum.app/site24x7').then((response) => {
          response.json().then((monitorIps) => {
            if (monitorIps.includes(ipv6) || monitorIps.includes(ipv4)) {
              userId = 'Site24x7 Monitor Tool';
              logrocketEnabled = false;
            }
            if (logrocketEnabled && logrocketToken) {
              // start log rocket
              LogRocket.init(logrocketToken, { release: process.env.VUE_APP_RELEASE });
              LogRocket.getSessionURL((sessionURL) => {
                if (analytics) {
                  analytics.track({
                    userId: userId,
                    event: 'Concierge: LogRocket Session',
                    properties: {
                      logRocketSessionURL: sessionURL,
                    },
                  });
                }
              });
              if (userId === 'Anonymous User') {
                // An interim way to notify us that someone is accessing Concierge... no alert for monitoring tool
                const newUserAlert: Error = new Error('****New access on Concierge production****');
                LogRocket.captureException(newUserAlert);
              } else {
                // have the log rocket UI show it as Site24x7 Monitor Tool
                LogRocket.identify(userId);
              }
            }
          });
        });
      });
    });
  });
});

// Show version for debugging purposes.
console.log('Signup Version: ', process.env.VUE_APP_RELEASE);

Vue.config.productionTip = false;

// @ts-ignore
Vue.use(SuiVue);

new Vue({
  router,
  render: (h: any) => h(App),
}).$mount('#app');
